import { render } from "./benefitCard.vue?vue&type=template&id=dcad2f6c"
import script from "./benefitCard.vue?vue&type=script&lang=js"
export * from "./benefitCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__